import { useQuery } from "@tanstack/react-query";

import { caseNotesApi } from "@/api";
import { withLocalErrorHandling } from "@/api/middleware/errorMiddleware";
import { QueryKey } from "@/query/Query";

/**
 * Looks up the register handle of the edict a case note of type "Edikt" holds. A failed lookup is reported as a
 * toast when the "§ SRV eröffnen" button is clicked, so loading raises no global error.
 */
export function useCaseNoteEdictQuery(clientId: string, caseNoteId: string) {
  return useQuery({
    queryKey: [QueryKey.CaseNoteEdict, clientId, caseNoteId],
    queryFn: () => caseNotesApi.getCaseNoteEdict({ clientId, noteId: caseNoteId }, withLocalErrorHandling),
    retry: false,
  });
}
